export default function LeftArrow() {
    return (
        <>
            <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.5 1.5L1.5 9L8.5 16.5" stroke="#1e2d5f" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

        </>
    )
}
